/**
 * @phxRouteModal
 */
import { EABError } from 'core-js-error';

export class phxRouteModalController {
  constructor(private $state: any) {}
}
export class RouteModalController {
  constructor(private $state: any, private $timeout: any, private phxFocusDelegate: any) {
    this.$timeout(() => {
      this.phxFocusDelegate.focus('routeModal');
    }, 1000);
  }
}

angular
  .module('ui-ng-route-modal', [])
  .controller('ngphxRouteModalController', phxRouteModalController)
  .component('phxRouteModal', {
    template: '<ui-view name="routeModal"/>',
    controller: 'ngphxRouteModalController',
    controllerAs: '$ctrl'
  });

angular.module('ui-ng-route-modal').config(($stateProvider: angular.ui.IStateProvider): void => {
  $stateProvider
    .state('my.routeModal', {
      url: 'modal/',
      views: {
        'routeModal@my': {
          templateUrl: 'ui-ng-route-modal/src/templates/ui-router-modal.html',
          controller: RouteModalController,
          controllerAs: '$ctrl'
        }
      },
      abstract: true
    })
    .state('advisor.student.routeModal', {
      url: 'modal/',
      views: {
        'routeModal@advisor.student': {
          templateUrl: 'ui-ng-route-modal/src/templates/ui-router-modal.html',
          controller: RouteModalController,
          controllerAs: '$ctrl'
        }
      },
      abstract: true
    });
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-route-modal/src/main.ts